import { utils, components } from '@digital-commerce/shared-utils'
import { Spacer } from '@telus-uds/components-web'

import { bool, object } from 'prop-types'
import { useContext } from 'react'
import { ResponsiveCard } from '../StyledContainers'

import localeContext from '../../../contexts/Locale'
import useTranslate from '../../../hooks/useTranslate'

import CartItem, { BasicInfo, ActionBar, OfferDetailsContainer } from '../../molecules/CartItem'
import {
  getAttributesToAppend,
  getChangeUrl,
  getCompassDiscountItem,
  getInternetMonthlyPrice
} from './utils'
import OfferDetails from './OfferDetails'
import { buildContractTermLabel, getHSAppliedPromoCodeText } from '../../../utils/display'
import useAuthentication from '../../../hooks/useAuthentication'
import { transformCancellationFeeContent, translateFootnoteKeys } from '../../../utils/cart'
import {
  getInternetAddons,
  getLegalFootnoteKeys,
  isSmartHubService
} from '../../../utils/homeSolutions'

const { getItemOneTimePrice, isBusinessCart } = utils.cart
const { WithLegal } = components

const Internet = ({ internet, cart, isRemoveButtonHidden, featureFlags, IRPCParams }) => {
  const { lang } = useContext(localeContext)

  const translate = useTranslate()
  const isAuthenticated = useAuthentication()
  const isSBSCart = isBusinessCart(cart)

  const compassDiscountItem = getCompassDiscountItem(cart)
  const internetAddons = getInternetAddons(internet)

  const { subTotal: dueTodaySubTotal } = getItemOneTimePrice(internet)
  const monthlySubTotal = getInternetMonthlyPrice({
    internet,
    compassDiscountItem,
    isIrpcFlow: IRPCParams.isIrpcFlow
  })

  const changeUrl = getChangeUrl({
    isAuthenticated,
    isBusinessCart: isSBSCart,
    isIrpcFlow: IRPCParams.isIrpcFlow,
    isSmartHubService: isSmartHubService(internet)
  })

  const appliedPromoCodeText = getHSAppliedPromoCodeText(internet, featureFlags, cart)

  const termsAndConditions = (
    <WithLegal
      content={translateFootnoteKeys(translate)(
        getLegalFootnoteKeys(internet, internetAddons, isSBSCart)
      )}
      onReceiveContent={transformCancellationFeeContent(internet, lang)}
      copy={lang}
    />
  )

  // Append internet credits, install type, addons
  const attributesToAppend = getAttributesToAppend({
    internetService: internet,
    internetAddons,
    cart,
    isBusinessCart: isSBSCart,
    translate
  })

  const term = buildContractTermLabel(translate, internet)

  return (
    <>
      <ResponsiveCard variant={{ border: 'line', padding: 'custom' }}>
        <CartItem cartItem={internet}>
          <BasicInfo
            subHeading={translate('subHeading')}
            dueTodaySubTotal={dueTodaySubTotal}
            monthlySubTotal={monthlySubTotal}
            changeUrl={changeUrl}
            term={term}
            appendAttributes={attributesToAppend}
            appliedPromoCodeText={appliedPromoCodeText}
            termsAndConditions={termsAndConditions}
          />
          <ActionBar isShowDetailsCtaHidden={false} isRemoveButtonHidden={isRemoveButtonHidden} />
          <OfferDetailsContainer>
            <OfferDetails
              internetService={internet}
              internetAddons={internetAddons}
              compassDiscountItem={compassDiscountItem}
              cart={cart}
              featureFlags={featureFlags}
              IRPCParams={IRPCParams}
              isBusinessCart={isSBSCart}
            />
          </OfferDetailsContainer>
        </CartItem>
      </ResponsiveCard>
      <Spacer space={5} />
    </>
  )
}

export default Internet

Internet.propTypes = {
  internet: object.isRequired,
  cart: object.isRequired,
  isRemoveButtonHidden: bool,
  featureFlags: object.isRequired,
  IRPCParams: object.isRequired
}

Internet.defaultProps = {
  isRemoveButtonHidden: false
}
